import { useEffect, useState } from "react";

export const usePlayerSlotManager = (attrName: string,
  slotValue: string | null) => {
  const [ targetEl, setTargetEl ] = useState<HTMLElement | null>(null);

  const update = () => {
    if (!slotValue) {
      setTargetEl(null);
      return;
    }

    const el = document.querySelector<HTMLElement>(`[${attrName}="${slotValue}"]`);
    if (el && targetEl !== el) {
      setTargetEl(el);
    }
  };

  useEffect(() => {
    update();

    const observer = new MutationObserver(update);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [ attrName ],
    });

    return () => observer.disconnect();
  }, [ slotValue, attrName ]);

  return {
    targetEl,
    isReady: !!targetEl,
  };
};
